import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CampaignSettings } from "../../types/common.types";

interface CampaignSettingsState {
  settings: CampaignSettings | null;
}

const initialState: CampaignSettingsState = {
  settings: null,
};

const CampaignSettingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<CampaignSettings>) => {
      state.settings = action.payload;
    },
    updateMaxDailyWins: (state, action: PayloadAction<number>) => {
      if (state.settings) {
        state.settings.maxDailyWins = action.payload;
      }
    },
  },
});

export const { setSettings, updateMaxDailyWins } =
  CampaignSettingsSlice.actions;
export default CampaignSettingsSlice.reducer;
